export class DateCellHelpers {
  static processValue(value, transform: (p) => string): string {
    return value && value.length > 0 ? transform(value) : '';
  }
}
